import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class names with conditional logic + de-duplication.
 *
 * Standard shadcn/ui helper — accepts the same inputs as `clsx` (strings,
 * arrays, objects with truthy keys) and passes the result through
 * `tailwind-merge` so conflicting utilities (e.g. `px-4 px-6`) collapse to
 * the last one.
 *
 *   cn('px-4', condition && 'px-6', { 'bg-red-500': isError })
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
